// extracted by mini-css-extract-plugin
export default {"display":"styles_display__IdvU+","editButton":"styles_editButton__6FyFm","editor":"styles_editor__yk5gp"};